export const UNAUTHENTICATED = "UNAUTHENTICATED";
export const AUTHENTICATED = "AUTHENTICATED";

interface Unauthenticated {
  type: typeof UNAUTHENTICATED;
}

interface Authenticated {
  type: typeof AUTHENTICATED;
  api_key: string;
}

export type State = Unauthenticated | Authenticated;
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";

interface Login {
  type: typeof LOGIN;
  api_key: string;
}

interface Logout {
  type: typeof LOGOUT;
}

export type Actions = Login | Logout;
